export const FIELD_META_BASE_SLOTS = {
	helpText: { description: 'custom helpText support (HTML)', scope: null },
}
